/**
 * เริ่มฟังคำสั่งระดับแอปจาก Firestore ตอนบูต — ตัวฟังอยู่ในสโตร์ appControl (source of truth)
 *
 * ใครจะทำอะไรเมื่อค่าเปลี่ยน ให้เขียนเป็น pinia plugin ของสโตร์นั้น เช่น
 * reload → plugins/appReload.plugin.ts (ต้องลงทะเบียนก่อนไฟล์นี้ ดู modules/core/index.ts)
 */
export default defineNuxtPlugin(() => {
  useAppControlStore().start(useBuildChannel());
});
